<script lang="ts">
    import type {UUID} from 'src/typings';
    import KpButtonStyleAnchor from 'shared/ui-widgets/button/KpButtonStyleAnchor.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';

    export let recordId: UUID;
</script>

<KpButtonStyleAnchor additionalClasses="record-link-eye-button"
                     href="/#!/records/{recordId}"
                     buttonStyle="link"
                     buttonSize="xs">

    <UIcon icon="eye"/>
</KpButtonStyleAnchor>

<style lang="less">
    @import (reference) "styles/portaro.themes.less";

    :global {
        .record-link-eye-button:hover {
            background-color: @themed-body-bg-blue-highlighted;
        }
    }
</style>